var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1891 7.5H19.8425C23.8792 7.5 26.6975 10.2817 26.6975 14.2682V25.7318C26.6975 29.7183 23.8792 32.5 19.8425 32.5H10.1891C6.15235 32.5 3.33398 29.7183 3.33398 25.7318V14.2682C3.33398 10.2817 6.15235 7.5 10.1891 7.5ZM33.264 11.465C33.9956 11.0927 34.854 11.1316 35.5523 11.5716C36.2506 12.0098 36.6673 12.7712 36.6673 13.6037V26.3973C36.6673 27.2315 36.2506 27.9912 35.5523 28.4294C35.1706 28.668 34.744 28.7898 34.314 28.7898C33.9556 28.7898 33.5973 28.7052 33.2623 28.5343L30.7939 27.289C29.8806 26.8254 29.3139 25.8948 29.3139 24.8609V15.1384C29.3139 14.1029 29.8806 13.1722 30.7939 12.712L33.264 11.465Z",
    fill: "#D1D7E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraGray);
export default __webpack_public_path__ + "static/media/cameraGray.5955a8fe.svg";
export { ForwardRef as ReactComponent };